module.exports = __webpack_public_path__ + "dd8adabd0bb689bba96db0f7d9c35e7b.png";